// extracted by mini-css-extract-plugin
export var auto = "_2r-1";
export var spinner = "_2r-0";